<a class="repository-container text-2" [class.link-end]="headerBDC" [href]="urlRepository" target="_blank">
  <span class="icon-gitlab"></span>
  <span class="text-gitLab">Ver en GitLab</span>
</a>
